import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from '../translations';

// Detect initial language from URL
const getInitialLanguage = () => {
  const path = window.location.pathname;
  return path.startsWith('/en') ? 'en' : 'nl';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: translations.nl },
      en: { translation: translations.en }
    },
    lng: getInitialLanguage(), // Detect from URL
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

